import { useState } from "react";
import { Multiselect } from "multiselect-react-dropdown";

function MultiSelectDropdown(props) {
    const [showError, setShowError] = useState(false);

    function blurHandler() {
        if (!props.value || props.value.length === 0) {
            setShowError(true);
            let inputErrors = [...props.inputErrors];
            inputErrors[props.index] = "error";
            props.setInputErrors(inputErrors);
        } else {
            setShowError(false);
            let inputErrors = [...props.inputErrors];
            inputErrors[props.index] = "";
            props.setInputErrors(inputErrors);
        }
    }

    function handleSelect(selectedList) {
        const selectedValues = selectedList.map((item) => item[props.valueKey]).join(", ");
        props.onChange({ target: { name: props.name, value: selectedValues } });
    }

    function handleRemove(selectedList) {
        const selectedValues = selectedList.map((item) => item[props.valueKey]).join(", ");
        props.onChange({ target: { name: props.name, value: selectedValues } });
    }

    return (
        <>
            <Multiselect
                options={props.options}
                selectedValues={props.value
                    ?.split(", ")
                    .map((val) => props.options.find((option) => option[props.valueKey] === val))
                    .filter(Boolean)}
                onSelect={handleSelect}
                onRemove={handleRemove}
                displayValue={props.nameKey}
                placeholder={`---Select ${props.placeHolder}---`}
                isObject={true}
                onBlur={blurHandler}
                style={{
                    multiselectContainer: { padding: "0px", margin: "0px", background: "#f0f4f8" },
                    searchBox: {
                        minHeight: "30px",
                        padding: "4px 8px",
                        fontSize: "8px",
                        borderRadius: "8px",
                    },
                    chips: {
                        fontSize: "10px",
                        padding: "2px 6px",
                        borderRadius: "6px",
                    },
                    optionContainer: {
                        background: "#f0f4f8",
                        maxHeight: "150px",
                        fontSize: "14px",
                    },
                    option: {
                        padding: "6px",
                        fontSize: "14px",
                    },
                }}
            />
            <div className="text-red-500 text-xs font-semibold px-2 ">
                {
                    (showError || (props.required && props.missingFields.includes(props.name))) && 'Required field!'
                }
                {
                    props.name === 'currency' && props.value?.length > 0 && !props.validCurrency.includes(props.value) && `Only ${props.validCurrency} is valid`
                }
            </div>
        </>
    );
}

export default MultiSelectDropdown;
